module.exports = __webpack_public_path__ + "img/RS1221RP+RS1221+.cf53dce2.png";